// extracted by mini-css-extract-plugin
export default {"placeholder":"home_placeholder__kcYAI","landingPage":"home_landingPage__EwdnM","visible":"home_visible__Sq7NJ","sections":"home_sections__OHry5"};